export default {
    state: {
      errMsg: '',
      showErrorConfirm: false
    },
    mutations: {
        SET_SHOW_ERR_CONFIRM: (state, showErrorConfirm) => {
            state.showErrorConfirm = showErrorConfirm
        },
        SET_ERR_MSG: (state, errMsg) => {
            state.errMsg = errMsg
        }
    },
    actions: {
        ShowErrorConfirm({ commit }) {
            commit('SET_SHOW_ERR_CONFIRM', true)
        },
        SetErrorMsg({ commit }, errMsg) {
            commit('SET_ERR_MSG', errMsg)
        }
    }
  }